import { render, staticRenderFns } from "./PbbCetakSPPT.vue?vue&type=template&id=28b46aa6&scoped=true&"
import script from "./PbbCetakSPPT.vue?vue&type=script&lang=js&"
export * from "./PbbCetakSPPT.vue?vue&type=script&lang=js&"
import style0 from "./PbbCetakSPPT.vue?vue&type=style&index=0&id=28b46aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b46aa6",
  null
  
)

export default component.exports